import { Fragment } from 'react';
import InputComponent from '../input';
import SelectDropdownSecondaryComponent from '../select-dropdown-secondary';
import IconButtonComponent from '../icon-button';
import { FilterFormActions, FiltersForm, FiltersWrapper } from './filters.style';

const FiltersComponent = ({ open, searchFields, handleChange, handleSubmit, cols }) => {
    return (
        <FiltersWrapper $open={open}>
            <FiltersForm onSubmit={handleSubmit} $cols={cols}>
                {
                    searchFields &&
                    searchFields.length > 0 &&
                    searchFields.map((field, index) => (
                        <Fragment key={index}>
                            {
                                ['text', 'number', 'email', 'tel', 'time', 'date', 'datetime-local'].includes(field.type) && (
                                    <div>
                                        {/* <label>{field.label}</label> */}
                                        <InputComponent
                                            label={field.label}
                                            type={field.type}
                                            placeholder={field.placeholder}
                                            name={field.name}
                                            value={field.value}
                                            onChange={handleChange}
                                            mui
                                        />
                                    </div>
                                )
                            }

                            {
                                field.type === 'select' && (
                                    <div>
                                        {/* <label>{field.label}</label> */}
                                        <SelectDropdownSecondaryComponent
                                            label={field.label}
                                            options={field.options}
                                            name={field.name}
                                            value={field.value}
                                            onChange={handleChange}
                                            mui
                                        />
                                    </div>
                                )
                            }

                            {
                                field.type === 'action' && field.actions.length > 0 && (
                                    <FilterFormActions>
                                        {
                                            field.actions.map((button, index) => (
                                                <IconButtonComponent
                                                    key={index}
                                                    icon={button.icon}
                                                    type={button.type}
                                                    outline={button?.outline ? true : undefined}
                                                    color={button?.color}
                                                    onClick={button.action}
                                                />
                                            ))
                                        }
                                    </FilterFormActions>
                                )
                            }
                        </Fragment>
                    ))
                }
            </FiltersForm>
        </FiltersWrapper>
    );
};

export default FiltersComponent;
